import { useState, useEffect } from "react";
import authFetch from "../authFetch";

/* ══ GROCERY INTELLIGENCE ADMIN ═══════════════════════════ */
export default function GroceryIntelligenceAdmin({platform, dispatch}){
  const API=typeof window!=="undefined"?window.location.origin:"";
  const [subTab,setSubTab]=useState("items");
  const [items,setItems]=useState([]);
  const [variants,setVariants]=useState([]);
  const [products,setProducts]=useState([]);
  const [categories,setCategories]=useState([]);
  const [importQueue,setImportQueue]=useState([]);
  const [providerMappings,setProviderMappings]=useState([]);
  const [analytics,setAnalytics]=useState(null);
  const [loading,setLoading]=useState(false);
  const [editItem,setEditItem]=useState(null);
  const [editVariant,setEditVariant]=useState(null);
  const [editProduct,setEditProduct]=useState(null);
  const [editMapping,setEditMapping]=useState(null);
  const [showAdd,setShowAdd]=useState(false);
  const [importSource,setImportSource]=useState("open_food_facts");
  const [importQuery,setImportQuery]=useState("");
  const [importLoading,setImportLoading]=useState(false);
  const [importResult,setImportResult]=useState(null);
  const [seedResult,setSeedResult]=useState(null);
  const [addForm,setAddForm]=useState({nameEn:"",nameAr:"",categoryId:"",defaultUnit:"pcs",synonyms:""});
  const [addVariantForm,setAddVariantForm]=useState({genericItemId:"",nameEn:"",nameAr:"",attributes:"{}"});
  const [addProductForm,setAddProductForm]=useState({variantId:"",brand:"",nameEn:"",nameAr:"",size:"",unit:"",barcode:""});
  const [addMappingForm,setAddMappingForm]=useState({productId:"",provider:"",externalSku:"",price:""});

  const fetchData=async(type)=>{
    try{
      const r=await authFetch(`${API}/api/grocery-catalog?type=${type}&limit=200`);
      const j=await r.json();return j.rows||[];
    }catch{return[];}
  };
  const reload=async()=>{
    setLoading(true);
    const[i,v,p,c,q]=await Promise.all([
      fetchData("generic_items"),fetchData("variants"),fetchData("products"),fetchData("categories"),
      authFetch(`${API}/api/grocery-import?status=all&limit=100`).then(r=>r.json()).then(j=>j.rows||[]).catch(()=>[]),
    ]);
    setItems(i);setVariants(v);setProducts(p);setCategories(c);setImportQueue(q);
    // Analytics
    try{const ar=await authFetch(`${API}/api/grocery-analytics?type=summary`);const aj=await ar.json();setAnalytics(aj.data||null);}catch{}
    // Provider mappings
    try{const mr=await authFetch(`${API}/api/grocery-providers`);const mj=await mr.json();setProviderMappings(mj.rows||[]);}catch{}
    setLoading(false);
  };
  useEffect(()=>{reload();},[]);

  const deleteItem=async(type,id)=>{
    if(!window.confirm("Delete this item?"))return;
    await authFetch(`${API}/api/grocery-catalog`,{method:"DELETE",headers:{"Content-Type":"application/json"},body:JSON.stringify({type,id})});
    reload();
  };
  const approveImport=async(id)=>{
    await authFetch(`${API}/api/grocery-import`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify({id,action:"approve"})});
    reload();
  };
  const rejectImport=async(id)=>{
    await authFetch(`${API}/api/grocery-import`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify({id,action:"reject"})});
    reload();
  };
  const runImport=async()=>{
    if(!importQuery.trim())return;
    setImportLoading(true);setImportResult(null);
    try{
      const r=await authFetch(`${API}/api/grocery-import?source=${importSource}`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({query:importQuery})});
      const j=await r.json();setImportResult(j);reload();
    }catch(e){setImportResult({error:e.message});}
    setImportLoading(false);
  };
  const runSeed=async()=>{
    setSeedResult(null);
    try{const r=await authFetch(`${API}/api/grocery-seed`,{method:"POST"});const j=await r.json();setSeedResult(j);reload();}catch(e){setSeedResult({error:e.message});}
  };
  const saveGenericItem=async()=>{
    if(editItem){
      await authFetch(`${API}/api/grocery-catalog`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify({type:"generic_items",id:editItem.id,patch:editItem})});
      setEditItem(null);reload();
    }
  };
  const addGenericItem=async()=>{
    const syns=addForm.synonyms?addForm.synonyms.split(",").map(s=>s.trim()).filter(Boolean):[];
    await authFetch(`${API}/api/grocery-catalog`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({type:"generic_items",row:{nameEn:addForm.nameEn,nameAr:addForm.nameAr,categoryId:addForm.categoryId,defaultUnit:addForm.defaultUnit,synonyms:syns,status:"active"}})});
    setShowAdd(false);setAddForm({nameEn:"",nameAr:"",categoryId:"",defaultUnit:"pcs",synonyms:""});reload();
  };
  const addVariant=async()=>{
    let attrs={};try{attrs=JSON.parse(addVariantForm.attributes);}catch{}
    await authFetch(`${API}/api/grocery-catalog`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({type:"variants",row:{genericItemId:addVariantForm.genericItemId,nameEn:addVariantForm.nameEn,nameAr:addVariantForm.nameAr,attributes:attrs,status:"active"}})});
    setAddVariantForm({genericItemId:"",nameEn:"",nameAr:"",attributes:"{}"});reload();
  };
  const addProduct=async()=>{
    await authFetch(`${API}/api/grocery-catalog`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({type:"products",row:{variantId:addProductForm.variantId,brand:addProductForm.brand,nameEn:addProductForm.nameEn,nameAr:addProductForm.nameAr,size:addProductForm.size,unit:addProductForm.unit,barcode:addProductForm.barcode,externalSource:"manual",status:"approved"}})});
    setAddProductForm({variantId:"",brand:"",nameEn:"",nameAr:"",size:"",unit:"",barcode:""});reload();
  };
  const addMapping=async()=>{
    await authFetch(`${API}/api/grocery-providers`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({product_id:addMappingForm.productId,provider:addMappingForm.provider,external_sku:addMappingForm.externalSku,price:parseFloat(addMappingForm.price)||null})});
    setAddMappingForm({productId:"",provider:"",externalSku:"",price:""});reload();
  };
  const togglePin=async(item)=>{
    await authFetch(`${API}/api/grocery-catalog`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify({type:"generic_items",id:item.id,patch:{isPinned:!item.isPinned}})});
    reload();
  };

  const TABS=[
    {k:"items",l:"Generic Items",count:items.length},
    {k:"variants",l:"Variants",count:variants.length},
    {k:"products",l:"Products",count:products.length},
    {k:"import",l:"Import Queue",count:importQueue.filter(q=>q.status==="pending").length},
    {k:"mappings",l:"Provider Mappings",count:providerMappings.length},
    {k:"analytics",l:"Analytics"},
    {k:"seed",l:"Seed Data"},
  ];
  const catName=(id)=>categories.find(c=>c.id===id)?.nameEn||"—";
  const giName=(id)=>items.find(i=>i.id===id)?.nameEn||"—";
  const varName=(id)=>variants.find(v=>v.id===id)?.nameEn||"—";
  const prodName=(id)=>products.find(p=>p.id===id)?.nameEn||"—";

  return(
    <div>
      <div className="p-section-hd">Grocery Intelligence System</div>
      <div style={{display:"flex",gap:6,marginBottom:16,flexWrap:"wrap"}}>
        {TABS.map(t=>(
          <button key={t.k} className={`p-btn-${subTab===t.k?"p":"s"}`} style={{fontSize:12,padding:"6px 12px"}} onClick={()=>setSubTab(t.k)}>
            {t.l}{t.count!=null?` (${t.count})`:""}
          </button>
        ))}
      </div>

      {loading&&<div style={{padding:20,textAlign:"center",color:"var(--cg400)"}}>Loading...</div>}

      {/* ── GENERIC ITEMS ── */}
      {subTab==="items"&&(
        <div>
          <div style={{display:"flex",gap:8,marginBottom:12}}>
            <button className="p-btn-p" style={{fontSize:12}} onClick={()=>setShowAdd(true)}>+ Add Generic Item</button>
          </div>
          {showAdd&&(
            <div className="p-card" style={{marginBottom:14}}>
              <div style={{fontSize:12,fontWeight:600,marginBottom:8}}>New Generic Item</div>
              <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:8}}>
                <input className="p-inp" placeholder="Name (English)" value={addForm.nameEn} onChange={e=>setAddForm(p=>({...p,nameEn:e.target.value}))} style={{flex:1,minWidth:150}}/>
                <input className="p-inp" placeholder="Name (Arabic)" value={addForm.nameAr} onChange={e=>setAddForm(p=>({...p,nameAr:e.target.value}))} style={{flex:1,minWidth:150}} dir="rtl"/>
                <select className="p-inp" value={addForm.categoryId} onChange={e=>setAddForm(p=>({...p,categoryId:e.target.value}))} style={{flex:1,minWidth:120}}>
                  <option value="">— Category —</option>
                  {categories.map(c=><option key={c.id} value={c.id}>{c.nameEn}</option>)}
                </select>
                <select className="p-inp" value={addForm.defaultUnit} onChange={e=>setAddForm(p=>({...p,defaultUnit:e.target.value}))} style={{width:80}}>
                  {["pcs","kg","g","L","ml"].map(u=><option key={u} value={u}>{u}</option>)}
                </select>
              </div>
              <div style={{display:"flex",gap:8,marginBottom:8}}>
                <input className="p-inp" placeholder="Synonyms (comma-separated)" value={addForm.synonyms} onChange={e=>setAddForm(p=>({...p,synonyms:e.target.value}))} style={{flex:1}}/>
              </div>
              <div style={{display:"flex",gap:8}}>
                <button className="p-btn-p" style={{fontSize:12}} onClick={addGenericItem}>Save</button>
                <button className="p-btn-s" style={{fontSize:12}} onClick={()=>setShowAdd(false)}>Cancel</button>
              </div>
            </div>
          )}
          {editItem&&(
            <div className="p-card" style={{marginBottom:14,border:"2px solid var(--cink)"}}>
              <div style={{fontSize:12,fontWeight:600,marginBottom:8}}>Edit: {editItem.nameEn}</div>
              <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:8}}>
                <input className="p-inp" value={editItem.nameEn||""} onChange={e=>setEditItem(p=>({...p,nameEn:e.target.value}))} style={{flex:1,minWidth:150}}/>
                <input className="p-inp" value={editItem.nameAr||""} onChange={e=>setEditItem(p=>({...p,nameAr:e.target.value}))} style={{flex:1,minWidth:150}} dir="rtl"/>
                <select className="p-inp" value={editItem.categoryId||""} onChange={e=>setEditItem(p=>({...p,categoryId:e.target.value}))} style={{flex:1,minWidth:120}}>
                  <option value="">— Category —</option>
                  {categories.map(c=><option key={c.id} value={c.id}>{c.nameEn}</option>)}
                </select>
              </div>
              <div style={{display:"flex",gap:8,marginBottom:8}}>
                <input className="p-inp" placeholder="Synonyms (comma-separated)" value={(editItem.synonyms||[]).join(", ")} onChange={e=>setEditItem(p=>({...p,synonyms:e.target.value.split(",").map(s=>s.trim()).filter(Boolean)}))} style={{flex:1}}/>
              </div>
              <div style={{display:"flex",gap:8}}>
                <button className="p-btn-p" style={{fontSize:12}} onClick={saveGenericItem}>Save Changes</button>
                <button className="p-btn-s" style={{fontSize:12}} onClick={()=>setEditItem(null)}>Cancel</button>
              </div>
            </div>
          )}
          <div className="p-card" style={{padding:0,overflow:"hidden"}}>
            <table className="p-table">
              <thead><tr><th>Name (EN)</th><th>Name (AR)</th><th>Category</th><th>Unit</th><th>Popularity</th><th>Pinned</th><th>Actions</th></tr></thead>
              <tbody>
                {items.map(item=>(
                  <tr key={item.id}>
                    <td style={{fontWeight:500}}>{item.nameEn}</td>
                    <td dir="rtl">{item.nameAr||"—"}</td>
                    <td>{catName(item.categoryId)}</td>
                    <td>{item.defaultUnit||"—"}</td>
                    <td>{item.popularityScore||0}</td>
                    <td><span style={{cursor:"pointer"}} onClick={()=>togglePin(item)}>{item.isPinned?"📌":"—"}</span></td>
                    <td>
                      <button className="p-btn-s" style={{fontSize:11,padding:"3px 8px",marginRight:4}} onClick={()=>setEditItem({...item})}>Edit</button>
                      <button className="p-btn-s" style={{fontSize:11,padding:"3px 8px",color:"#d44"}} onClick={()=>deleteItem("generic_items",item.id)}>Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {!items.length&&<div style={{padding:20,textAlign:"center",color:"var(--cg400)"}}>No generic items. Use "Seed Data" tab to populate.</div>}
          </div>
        </div>
      )}

      {/* ── VARIANTS ── */}
      {subTab==="variants"&&(
        <div>
          <div className="p-card" style={{marginBottom:14}}>
            <div style={{fontSize:12,fontWeight:600,marginBottom:8}}>Add Variant</div>
            <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:8}}>
              <select className="p-inp" value={addVariantForm.genericItemId} onChange={e=>setAddVariantForm(p=>({...p,genericItemId:e.target.value}))} style={{flex:1,minWidth:150}}>
                <option value="">— Generic Item —</option>
                {items.map(i=><option key={i.id} value={i.id}>{i.nameEn}</option>)}
              </select>
              <input className="p-inp" placeholder="Variant Name (EN)" value={addVariantForm.nameEn} onChange={e=>setAddVariantForm(p=>({...p,nameEn:e.target.value}))} style={{flex:1,minWidth:150}}/>
              <input className="p-inp" placeholder="Name (AR)" value={addVariantForm.nameAr} onChange={e=>setAddVariantForm(p=>({...p,nameAr:e.target.value}))} style={{flex:1,minWidth:120}} dir="rtl"/>
            </div>
            <div style={{display:"flex",gap:8,marginBottom:8}}>
              <input className="p-inp" placeholder='Attributes JSON e.g. {"fat_pct":"3.5"}' value={addVariantForm.attributes} onChange={e=>setAddVariantForm(p=>({...p,attributes:e.target.value}))} style={{flex:1}}/>
              <button className="p-btn-p" style={{fontSize:12}} onClick={addVariant}>Add</button>
            </div>
          </div>
          <div className="p-card" style={{padding:0,overflow:"hidden"}}>
            <table className="p-table">
              <thead><tr><th>Variant Name</th><th>Arabic</th><th>Generic Item</th><th>Attributes</th><th>Actions</th></tr></thead>
              <tbody>
                {variants.map(v=>(
                  <tr key={v.id}>
                    <td style={{fontWeight:500}}>{v.nameEn}</td>
                    <td dir="rtl">{v.nameAr||"—"}</td>
                    <td>{giName(v.genericItemId)}</td>
                    <td style={{fontSize:11,fontFamily:"monospace"}}>{JSON.stringify(v.attributes||{}).slice(0,50)}</td>
                    <td><button className="p-btn-s" style={{fontSize:11,padding:"3px 8px",color:"#d44"}} onClick={()=>deleteItem("variants",v.id)}>Delete</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
            {!variants.length&&<div style={{padding:20,textAlign:"center",color:"var(--cg400)"}}>No variants yet.</div>}
          </div>
        </div>
      )}

      {/* ── PRODUCTS ── */}
      {subTab==="products"&&(
        <div>
          <div className="p-card" style={{marginBottom:14}}>
            <div style={{fontSize:12,fontWeight:600,marginBottom:8}}>Add Product</div>
            <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:8}}>
              <select className="p-inp" value={addProductForm.variantId} onChange={e=>setAddProductForm(p=>({...p,variantId:e.target.value}))} style={{flex:1,minWidth:150}}>
                <option value="">— Variant —</option>
                {variants.map(v=><option key={v.id} value={v.id}>{v.nameEn} ({giName(v.genericItemId)})</option>)}
              </select>
              <input className="p-inp" placeholder="Brand" value={addProductForm.brand} onChange={e=>setAddProductForm(p=>({...p,brand:e.target.value}))} style={{flex:1,minWidth:100}}/>
              <input className="p-inp" placeholder="Product Name (EN)" value={addProductForm.nameEn} onChange={e=>setAddProductForm(p=>({...p,nameEn:e.target.value}))} style={{flex:1,minWidth:150}}/>
            </div>
            <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:8}}>
              <input className="p-inp" placeholder="Name (AR)" value={addProductForm.nameAr} onChange={e=>setAddProductForm(p=>({...p,nameAr:e.target.value}))} style={{flex:1,minWidth:120}} dir="rtl"/>
              <input className="p-inp" placeholder="Size (e.g. 1L)" value={addProductForm.size} onChange={e=>setAddProductForm(p=>({...p,size:e.target.value}))} style={{width:80}}/>
              <input className="p-inp" placeholder="Unit" value={addProductForm.unit} onChange={e=>setAddProductForm(p=>({...p,unit:e.target.value}))} style={{width:60}}/>
              <input className="p-inp" placeholder="Barcode" value={addProductForm.barcode} onChange={e=>setAddProductForm(p=>({...p,barcode:e.target.value}))} style={{flex:1,minWidth:120}}/>
              <button className="p-btn-p" style={{fontSize:12}} onClick={addProduct}>Add</button>
            </div>
          </div>
          <div className="p-card" style={{padding:0,overflow:"hidden"}}>
            <table className="p-table">
              <thead><tr><th>Product</th><th>Brand</th><th>Variant</th><th>Size</th><th>Barcode</th><th>Source</th><th>Status</th><th>Actions</th></tr></thead>
              <tbody>
                {products.map(p=>(
                  <tr key={p.id}>
                    <td style={{fontWeight:500}}>{p.nameEn}</td>
                    <td>{p.brand||"—"}</td>
                    <td>{varName(p.variantId)}</td>
                    <td>{p.size||"—"}</td>
                    <td style={{fontSize:11,fontFamily:"monospace"}}>{p.barcode||"—"}</td>
                    <td><span style={{fontSize:11,padding:"2px 6px",background:"var(--cg50)",borderRadius:4}}>{p.externalSource||"manual"}</span></td>
                    <td><span className={`pill ${p.status==="approved"?"p-done":p.status==="rejected"?"p-high":"p-open"}`}>{p.status}</span></td>
                    <td><button className="p-btn-s" style={{fontSize:11,padding:"3px 8px",color:"#d44"}} onClick={()=>deleteItem("products",p.id)}>Delete</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
            {!products.length&&<div style={{padding:20,textAlign:"center",color:"var(--cg400)"}}>No products yet.</div>}
          </div>
        </div>
      )}

      {/* ── IMPORT QUEUE ── */}
      {subTab==="import"&&(
        <div>
          <div className="p-card" style={{marginBottom:14}}>
            <div style={{fontSize:12,fontWeight:600,marginBottom:8}}>Import from External Source</div>
            <div style={{display:"flex",gap:8,marginBottom:8}}>
              <select className="p-inp" value={importSource} onChange={e=>setImportSource(e.target.value)} style={{width:180}}>
                <option value="open_food_facts">Open Food Facts</option>
                <option value="edamam">Edamam</option>
                <option value="spoonacular">Spoonacular</option>
              </select>
              <input className="p-inp" placeholder="Search query (e.g. milk, rice)" value={importQuery} onChange={e=>setImportQuery(e.target.value)} style={{flex:1}} onKeyDown={e=>e.key==="Enter"&&runImport()}/>
              <button className="p-btn-p" style={{fontSize:12}} onClick={runImport} disabled={importLoading}>{importLoading?"Importing...":"Import"}</button>
            </div>
            {importResult&&(
              <div className={importResult.error?"p-err":"p-ok"} style={{padding:"8px 12px",borderRadius:6,fontSize:12,marginTop:6}}>
                {importResult.error||`Fetched ${importResult.fetched} items, queued ${importResult.queued} for review.`}
              </div>
            )}
          </div>
          <div className="p-section-hd" style={{fontSize:13}}>Review Queue</div>
          <div className="p-card" style={{padding:0,overflow:"hidden"}}>
            <table className="p-table">
              <thead><tr><th>Name</th><th>Brand</th><th>Source</th><th>Matched Item</th><th>Confidence</th><th>Status</th><th>Actions</th></tr></thead>
              <tbody>
                {importQueue.map(q=>{
                  const norm=q.normalizedData||{};
                  return(
                    <tr key={q.id}>
                      <td style={{fontWeight:500}}>{norm.name||"—"}</td>
                      <td>{norm.brand||"—"}</td>
                      <td><span style={{fontSize:11,padding:"2px 6px",background:"var(--cg50)",borderRadius:4}}>{q.source}</span></td>
                      <td>{q.matchedGenericItemId?giName(q.matchedGenericItemId):"No match"}</td>
                      <td>{q.matchConfidence!=null?`${(q.matchConfidence*100).toFixed(0)}%`:"—"}</td>
                      <td><span className={`pill ${q.status==="approved"?"p-done":q.status==="rejected"?"p-high":"p-open"}`}>{q.status}</span></td>
                      <td>
                        {q.status==="pending"&&<>
                          <button className="p-btn-p" style={{fontSize:11,padding:"3px 8px",marginRight:4}} onClick={()=>approveImport(q.id)}>Approve</button>
                          <button className="p-btn-s" style={{fontSize:11,padding:"3px 8px",color:"#d44"}} onClick={()=>rejectImport(q.id)}>Reject</button>
                        </>}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {!importQueue.length&&<div style={{padding:20,textAlign:"center",color:"var(--cg400)"}}>No imports in queue.</div>}
          </div>
        </div>
      )}

      {/* ── PROVIDER MAPPINGS ── */}
      {subTab==="mappings"&&(
        <div>
          <div className="p-card" style={{marginBottom:14}}>
            <div style={{fontSize:12,fontWeight:600,marginBottom:8}}>Add Provider Mapping</div>
            <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:8}}>
              <select className="p-inp" value={addMappingForm.productId} onChange={e=>setAddMappingForm(p=>({...p,productId:e.target.value}))} style={{flex:1,minWidth:180}}>
                <option value="">— Product —</option>
                {products.map(p=><option key={p.id} value={p.id}>{p.nameEn} ({p.brand||"No brand"})</option>)}
              </select>
              <select className="p-inp" value={addMappingForm.provider} onChange={e=>setAddMappingForm(p=>({...p,provider:e.target.value}))} style={{width:150}}>
                <option value="">— Provider —</option>
                <option value="nana_direct">Nana Direct</option>
                <option value="carrefour">Carrefour</option>
                <option value="tamimi">Tamimi Markets</option>
                <option value="danube">Danube</option>
                <option value="panda">Panda</option>
              </select>
              <input className="p-inp" placeholder="External SKU" value={addMappingForm.externalSku} onChange={e=>setAddMappingForm(p=>({...p,externalSku:e.target.value}))} style={{flex:1,minWidth:120}}/>
              <input className="p-inp" placeholder="Price (SAR)" value={addMappingForm.price} onChange={e=>setAddMappingForm(p=>({...p,price:e.target.value}))} style={{width:90}} type="number"/>
              <button className="p-btn-p" style={{fontSize:12}} onClick={addMapping}>Add</button>
            </div>
          </div>
          <div className="p-card" style={{padding:0,overflow:"hidden"}}>
            <table className="p-table">
              <thead><tr><th>Product</th><th>Provider</th><th>External SKU</th><th>Price (SAR)</th><th>Last Synced</th></tr></thead>
              <tbody>
                {providerMappings.map(m=>(
                  <tr key={m.id}>
                    <td>{prodName(m.productId)}</td>
                    <td>{m.provider}</td>
                    <td style={{fontFamily:"monospace",fontSize:11}}>{m.externalSku}</td>
                    <td>{m.price||"—"}</td>
                    <td style={{fontSize:11}}>{m.lastSyncedAt?new Date(m.lastSyncedAt).toLocaleDateString():"—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {!providerMappings.length&&<div style={{padding:20,textAlign:"center",color:"var(--cg400)"}}>No provider mappings.</div>}
          </div>
        </div>
      )}

      {/* ── ANALYTICS ── */}
      {subTab==="analytics"&&(
        <div>
          {analytics&&(
            <div className="p-stat-grid" style={{marginBottom:16}}>
              {[
                {l:"Generic Items",v:analytics.total_generic_items},
                {l:"Products",v:analytics.total_products},
                {l:"Pending Imports",v:analytics.pending_imports},
                {l:"Searches (30d)",v:analytics.total_searches_last_30d},
              ].map(s=>(
                <div key={s.l} className="p-stat"><div className="p-stat-l">{s.l}</div><div className="p-stat-v">{s.v}</div></div>
              ))}
            </div>
          )}
          <div className="p-card">
            <div style={{fontSize:13,color:"var(--cg400)",padding:16,textAlign:"center"}}>
              Analytics dashboards (top searched, top selected, failed searches) will populate as users interact with the grocery search.
            </div>
          </div>
        </div>
      )}

      {/* ── SEED DATA ── */}
      {subTab==="seed"&&(
        <div>
          <div className="p-card">
            <div style={{fontSize:12,fontWeight:600,marginBottom:8}}>Seed Sample Data</div>
            <div style={{fontSize:13,color:"var(--cg500)",lineHeight:1.6,marginBottom:14}}>
              Populates the grocery database with 60+ generic items, 15+ categories, variants, and sample products with Saudi-specific brands and Arabic names. Safe to run multiple times (uses upsert).
            </div>
            <button className="p-btn-p" onClick={runSeed}>Run Seed</button>
            {seedResult&&(
              <div className={seedResult.error?"p-err":"p-ok"} style={{padding:"8px 12px",borderRadius:6,fontSize:12,marginTop:10}}>
                {seedResult.error||`Seeded: ${seedResult.seeded?.categories||0} categories, ${seedResult.seeded?.generic_items||0} items, ${seedResult.seeded?.variants||0} variants, ${seedResult.seeded?.products||0} products`}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
